import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FileText } from "lucide-react";
import MintSlip from '../assests/mintslip-logo.png';
import '../marketing-nav.css';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export default function Header({ title }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [authEnabled, setAuthEnabled] = useState(true);

  // Check for logged in user
  useEffect(() => {
    const userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
      try {
        setUser(JSON.parse(userInfo));
      } catch (e) {
        setUser(null);
      }
    }
  }, []);

  // Fetch auth status
  useEffect(() => {
    fetch(`${BACKEND_URL}/api/auth-status`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setAuthEnabled(data.authEnabled !== false);
      })
      .catch(() => {});
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  // Scroll to a home page section; from other pages, go home first (Home
  // reads the hash on load and scrolls there).
  const goToSection = (id) => {
    if (location.pathname === "/") {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate(`/#${id}`);
    }
  };

  return (
    <>
      {/* Green wash behind the navbar — whodat's purple top wash, in green.
          Anchored to the page top so it scrolls away while the pill sticks. */}
      <div aria-hidden="true" className="nav-wash" />

      {/* Floating glass pill header (whodat marketing nav) */}
      <div className="navbar">
        <nav className="navbar-pill">
          <button className="navbar-brand" onClick={() => navigate("/")} aria-label="MintSlip home">
            <img src={MintSlip} alt="MintSlip" />
          </button>

          <div className="navbar-links">
            <a onClick={() => goToSection("how-it-works")}>How it works</a>
            <a onClick={() => goToSection("reviews")}>Reviews</a>
            <a onClick={() => goToSection("compare")}>Compare</a>
            <a onClick={() => goToSection("faq")}>FAQ</a>
          </div>

          <div className="navbar-actions">
            {/* Signed-in visitors manage their account inside /app, so the
                navbar shows only the CTA for them; signed-out ones get Log in */}
            {!user && authEnabled && (
              <button className="navbar-secondary" onClick={() => handleNavigation("/login")}>Log in</button>
            )}
            <button className="navbar-cta" onClick={() => handleNavigation("/app")}>
              <FileText size={18} />
              <span>Create a paystub</span>
            </button>


          </div>
        </nav>
      </div>
    </>
  );
}



